import { useEffect } from 'react';

import { EmbedData } from './../../../../../store/modules/hostedVideo';

declare global {
  interface Window {
    wavePopover: {
      init: () => void;
      reInit: () => void;
      inited: boolean;
    };
  }
}

export const useReinitPopover = (embedData: EmbedData | null) => {
  useEffect(() => {
    if (embedData?.type !== 'popover') return;

    window.wavePopover?.reInit?.();
  }, [
    embedData?.type,
    embedData?.sizes,
    embedData?.popover.text,
    embedData?.popover?.popoverType,
    embedData?.popover.button.enabled
  ]);
};
